"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxComponent = exports.SeparatorComponent = exports.LabelComponent = void 0;
const BaseComponent_1 = require("./BaseComponent");
/**
 * 标签组件
 * 用于显示静态文本
 */
class LabelComponent extends BaseComponent_1.BaseComponent {
    constructor(text, container) {
        super(container);
        this._text = text;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置文本内容
     */
    get text() {
        return this._text;
    }
    set text(v) {
        this._text = v;
        this.textElement.textContent = v;
    }
    createElement() {
        this.textElement = document.createElement('div');
        this.element = this.textElement;
    }
    render() {
        // 设置样式类
        this.textElement.className = 'nexus-label';
        this.textElement.textContent = this._text;
        // 添加到容器
        this.container.appendChild(this.textElement);
    }
}
exports.LabelComponent = LabelComponent;
/**
 * 分隔符组件
 * 用于在UI中创建视觉分隔
 */
class SeparatorComponent extends BaseComponent_1.BaseComponent {
    constructor(container) {
        super(container);
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    createElement() {
        this.separatorElement = document.createElement('hr');
        this.element = this.separatorElement;
    }
    render() {
        // 设置样式类
        this.separatorElement.className = 'nexus-separator';
        // 添加到容器
        this.container.appendChild(this.separatorElement);
    }
}
exports.SeparatorComponent = SeparatorComponent;
/**
 * 信息框组件
 * 用于显示带有特定类型的信息提示
 */
class InfoBoxComponent extends BaseComponent_1.BaseComponent {
    constructor(text, type = 'info', container) {
        super(container);
        this._text = text;
        this._type = type;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置文本内容
     */
    get text() {
        return this._text;
    }
    set text(v) {
        this._text = v;
        this.textElement.textContent = v;
    }
    /**
     * 获取/设置信息类型
     */
    get type() {
        return this._type;
    }
    set type(v) {
        if (this._type !== v) {
            // 移除旧的类型样式
            this.wrapperElement.classList.remove(`nexus-infobox-${this._type}`);
            this._type = v;
            // 添加新的类型样式
            this.wrapperElement.classList.add(`nexus-infobox-${this._type}`);
            // 更新图标
            this.updateIcon();
        }
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.iconElement = document.createElement('span');
        this.textElement = document.createElement('div');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置基础样式类
        this.wrapperElement.className = `nexus-infobox nexus-infobox-${this._type}`;
        this.iconElement.className = 'nexus-infobox-icon';
        this.textElement.className = 'nexus-infobox-text';
        // 设置文本内容
        this.textElement.textContent = this._text;
        // 设置图标
        this.updateIcon();
        // 组装DOM结构
        this.wrapperElement.appendChild(this.iconElement);
        this.wrapperElement.appendChild(this.textElement);
        this.container.appendChild(this.wrapperElement);
    }
    /**
     * 更新图标
     */
    updateIcon() {
        if (!this.iconElement)
            return;
        // 根据类型设置不同的图标
        switch (this._type) {
            case 'info':
                this.iconElement.textContent = 'ℹ';
                break;
            case 'warning':
                this.iconElement.textContent = '⚠';
                break;
            case 'error':
                this.iconElement.textContent = '✖';
                break;
            case 'success':
                this.iconElement.textContent = '✓';
                break;
        }
    }
}
exports.InfoBoxComponent = InfoBoxComponent;
